import  { useEffect, useState } from 'react'
import { YOUTUBE_VIDEOS_API } from '../utils/constants'
import VideoCard, {AdVideoCard} from './VideoCard'
import { Link } from 'react-router-dom';


const VideoContainer = () => {
  const [videos, setVideos] = useState([]);
  useEffect(()=>{
    getVideos()
  },[])

  const getVideos = async() => {
      const data = await fetch(YOUTUBE_VIDEOS_API);
      const json = await data.json()
      setVideos(json.items);
      console.log(videos);
      
  } 

  const PromotedVideoCard = AdVideoCard(VideoCard);
 
  return (
      <div className='flex flex-wrap'>
        {videos.map((video)=>(<Link to={"/watch?v=" + video.id} key={video.id}>
        {video.snippet.defaultLanguage=== "mr"?
         (<PromotedVideoCard info={video}/>) :
         (<VideoCard info={video}/>)
        }
         </Link> ))}
      </div>
  )
}

export default VideoContainer


